<template>
	<div class="header-icon home-icon" @click="clickIcon">
		<router-link to="/">
			<font-awesome-icon icon="home" />
			<p>Home</p>
		</router-link>
	</div>
</template>

<script>
	import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

	export default {
		name: 'HomeIcon',
		data() {
			return {
				thisUrl: null
			}
		},
		created() {
			this.thisUrl = this.$router.currentRoute.path;
		},
		components: {
			FontAwesomeIcon
		},
		methods: {
			clickIcon() {
				if (this.thisUrl === '/') window.location = '/';
			}
		}
	}
</script>

<style lang="scss" scoped>
	.home-icon {
		text-align:center;
	}
</style>
